import axios from 'axios';
import { useMutation } from 'react-query';
import { KA_API_URL } from '../../config/baseUrl';

/**
 * Requests
 */

export const updatePerformanceSettings = async performanceSettings =>
  axios.put(`${KA_API_URL}/config/performance_settings`, performanceSettings);

/**
 * Hooks
 */

export const useUpdatePerformanceSettings = mutationConfig =>
  useMutation(async performanceSettings => {
    const response = await updatePerformanceSettings(performanceSettings);

    return response?.data ?? {};
  }, mutationConfig);
